import store from 'js/components/shared/store'

const getStore = async () => new Promise((resolve) => {
  const interval = setInterval(() => {
    if (window._store) {
      resolve(window._store)
    } else {
      resolve(store)
    }
    clearInterval(interval)
  }, 100)
})
export default getStore
